import config from '../scripts/config';
import countriesJson from '../country-data/countries-intl-custom.json'
import languages from '../country-data/languages-iso-639-1.json';
import Translator from '../scripts/translate.js';
import {
  findClosestLocale,
  getAvailableLocales,
  getPreferredCountryAndLanguage,
  localiseFontAndLinks
} from '../scripts/localisation';

const countryAndLanguage = getPreferredCountryAndLanguage();
const closestLocale = findClosestLocale(countryAndLanguage.language, countryAndLanguage.country, getAvailableLocales());


const localePickerElemId = 'localePickerSelect';
const defaultLocale = 'en-GB';
let inputCodeTextValue = '';

window.addEventListener('load', () => {
  initLocalePicker();
});


function initLocalePicker() {
  let options = countriesJson.sort((a, b) => {
    return (a.name < b.name) ? -1 : 1
  }).map((country) => {
    let localeOptions = '';
    country.locales.forEach((locale) => {
      let language = languages[locale.substr(0, 2)];
      let value = locale;

      // if there is no valid locale set for the language, use the default one
      // this is an edge-case
      if (!language) {
        language = languages[country.languages[0]];
      }

      // if locale contains only the language part, append the country (region) code
      if (value.length == 2) {
        value += '-' + country.internet;
      }

      const optionText = `${country.name} (${language.name})`;
      const defaultLanguageCode = (country.default_locale).substr(0, 2);
      localeOptions += `<option value="${value}" data-lang-code="${defaultLanguageCode}">${optionText}</option>`;
    });
    return localeOptions;
  }).join('');

  const localePicker = document.getElementById(localePickerElemId);
  localePicker.innerHTML = options;

  localePicker.addEventListener('change', (event) => {
    localisePage(event.target.value);
  });

  setDefaultLocaleOption();
  showPage();
}

function showPage() {
  document.body.style.visibility = 'visible';
}

function setDefaultLocaleOption() {
  const localeOptions = Array.from(document.getElementById(localePickerElemId).options);

  // try to set locale based on browser locale (i.e. de-AT)
  let defaultOption = localeOptions.find((option) => {
    return option.value.toLowerCase() == closestLocale;
  });

  // if locale isn't available, set it to default one
  if (!defaultOption) {
    defaultOption = localeOptions.find((option) => {
      return option.value == defaultLocale;
    });
  }

  document.getElementById(localePickerElemId).value = defaultOption.value;
  localisePage(defaultOption.value);
}

async function verifyCode() {
  const codeInput = document.getElementById('codeInput');
  const code = codeInput.value;

  const response = await fetch(`${config.verifyCodeEndpoint}?code=${code}`);
  const responsebody = await response.json();
  if (response.ok) {
    console.log('Code verified succesfully, redirecting...');
    redirectToUserFlow(responsebody.auth_url);
  } else {
    showCodeErrorLabel('Invalid code');
  }
}

function redirectToUserFlow(userFlowUrl) {
  const locale = document.getElementById(localePickerElemId).value;
  window.location = `${userFlowUrl}&ui_locales=${locale}`;
}

function showCodeErrorLabel(errorText) {
  const codeInputLabel = document.getElementById('codeInputLabel');
  codeInputLabel.style.visibility = 'visible';
  codeInputLabel.value = errorText;
}

const btnNext = document.getElementById('btnNext');
btnNext.addEventListener('click', (e) => {
  var form = document.getElementById("codeForm");
  if (form.checkValidity()) {
    e.preventDefault();
    verifyCode()
  }
});

const codeInput = document.getElementById('codeInput');
codeInput.addEventListener('input', () => {
  const codeInputLabel = document.getElementById('codeInputLabel');
  codeInputLabel.style.visibility = 'hidden';
  if (codeInput.value.length >= inputCodeTextValue.length) {
    const sanitizedValue = codeInput.value.replaceAll('-', '').split('');
    inputCodeTextValue = '';
    sanitizedValue.forEach((c, index) => {
      index++;
      inputCodeTextValue += c;
      if (index > 0 && index < 9 && index % 3 === 0) {
        inputCodeTextValue += '-';
      }
    });
    codeInput.value = inputCodeTextValue;
  } else {
    inputCodeTextValue = codeInput.value;
  }
});

function translatePage(translator) {
  document.getElementById('formTitle').innerText = translator.translate('codeInputPage.title');
  document.getElementById('btnNext').innerText = translator.translate('generic.continue');
  document.getElementById('codeInputLabel').innerText = translator.translate('codeInputPage.invalidCodeLabel');
}

function localisePage(locale) {
  const translator = new Translator();
  translator.init(locale);
  translatePage(translator);
  localiseFontAndLinks(locale.substring(0, 2), translator);
}
